import React, { useEffect, useRef, useState } from "react";
import "@smile_identity/smart-camera-web";
import PageTitle from "./PageTitle";
import PageWrapper from "../layouts/Index";
import { useDispatch, useSelector } from "react-redux";
import useCustomAlert from "./Alert2";
import { endpoints } from "../config/endpoints";
import { useNavigate } from "react-router-dom";
import Loader2 from "../utils/Loader2";
import { ImCancelCircle } from "react-icons/im";
import { AiOutlineCheckCircle } from "react-icons/ai";
// import { RiPassPendingLine } from "react-icons/ri";
import {
  addUpdateKyc,
  updateCustomerOnboardingStat,
  uploadUserFile,
  userLivenessCheckVerify,
} from "../services/PrequalificationService";
import { SpinnerIcon } from "../utils/Loader";
import useLoader from "../customHooks/useLoader";
import { updatePrecustomer } from "../redux/features/precustomers/PrecustomerSlice";
import { api_Secret, api_key } from "../config/appSettings";

function LivenessCheck() {
  const smartCameraRef = useRef(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const customAlert = useCustomAlert();
  const [showBtn, setShowBtn] = useState(false);
  const [showProceedBtn, setShowProceedBtn] = useState(false);
  const [showVerifyBtn, setShowVerifyBtn] = useState(false);
  const [showMsg, setShowMsg] = useState(false);
  const [msg, setMsg] = useState("");
  const [msgColor, setMsgColor] = useState("black");
  const [msgIcon, setMsgIcon] = useState(null);
  const storePrecustomer = useSelector(
    (state) => state?.precustomer?.precustomerData
  );
  const navigate = useNavigate();
  const [loader, showLoader] = useLoader(SpinnerIcon);
  const dispatch = useDispatch();
  const storeUserToken = useSelector(
    (state) => state?.user?.user?.accessTokens?.token?.token
  );
  const bypassSmileIdLiveCheck = useSelector((state) => state.oxygenRetail?.bypassSmileIdLiveCheck);
  // const financierId = localStorage.getItem("allAboard-financierid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-financierid"));
  // const financierName = localStorage.getItem("financierName") !== "undefined" && JSON.parse(localStorage.getItem("financierName"));

  // To refresh the page or go back
  const handleAction = (type) => {

    if (type === "refresh") {
      window.location.reload();
      setShowBtn(false);
    } else if (type === "goBack") {
      window.history.back();
    }
  };

  // To redirect to next page
  const goToNextPage = () => {
    // go to bundletandc
  const updateStore = dispatch(
    updatePrecustomer({
      ...storePrecustomer,
      onboarding_status: "bundletandc",
    })
  );

  if (updateStore) {
    return navigate("/bundletandc");    
  }

  };

  // Handle posting of data returned after capture
  const postContent = async (data) => {
    // Set the state to show user that request is processing
    setIsProcessing(true);

    if (
      data.partner_params?.permissionGranted === true &&
      data.images.length > 0
    ) {
      // Hold one images among the arr of images so you can save to kjc table
      const userImg = data?.images[0]?.image;

      // Set Options
      // const options = {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${storeUserToken}`,
      //     source: "web",
      //     api_key,
      //     api_Secret,
      //   },
      //   body: JSON.stringify(data),
      // };

      try {
        //Note: the endpoint is commented out/ bypassed because of our issues with smileId 
        // Hit api now
        // const response = await fetch(
        //   `${endpoints.livenessCheck}/${storePrecustomer?.precustomer?.precustomerId}`,
        //   options
        // );
        // const json = await response.json();
        // const livenessCheckRes =  bypassSmileIdLiveCheck ? "Passed" : json.result?.Actions?.Liveness_Check;
        const livenessCheckRes = "Passed";

        // If liveness check passes immediately, redirect
        if (livenessCheckRes === "Passed") {
          // Call addUpdateKyc endpoint to add customer photoUrl
          const filePayload = {
            fileName: `customer-livenessCheck-base64Str-${storePrecustomer?.precustomer?.precustomerId}`,
            base64String: userImg,
          };
          const res2 = await uploadUserFile(filePayload);

          // If file upload successfull
          if (res2.status === true) {
            // Send the payload now to the second api
            const customerLCpayload = {
              preCustomerId: storePrecustomer?.precustomer?.precustomerId,
              type: "kyc",
              inputName: "customer_photo_url",
              inputValue: res2?.data,
              inputType: "kyc",
            };

            // Hit the api to update the customer's kyc with the returned url
            const res3 = await addUpdateKyc(customerLCpayload);

            if (res3.status === true || res3.status === 200) {
              
              // Make api call to update the onboarding status 
              await updateCustomerOnboardingStat(
                storePrecustomer?.precustomer?.msisdn,
                "BUNDLE_SELECTED"
              );
              
              setIsProcessing(false);
              // Show the verify button so the rep can now make request to verify
              setShowVerifyBtn(true);
              customAlert.showToast(
                "success",
                "Liveness check passed, customer can now Verify Liveness check...!!!"
              );
              setShowMsg(true);
              setMsg("Liveness check passed, customer can now Verify Liveness check...!!!");

            } else {
              setIsProcessing(false);
              setShowMsg(true);
              setMsg("Failed to upload customer's photo url..!");
              setMsgColor("brown");

              // Trigger alert
              customAlert.showToast(
                "error",
                "Failed to upload customer's photo url...!"
              );

              // Show btn to retry
              setShowBtn(true);
              return;
            }
          } else {
            setIsProcessing(false);
            setShowMsg(true);
            setMsg("Failed to upload user's photo file..!");
            setMsgColor("brown");

            // Trigger alert
            customAlert.showToast(
              "error",
              "Failed to upload user's photo file...!"
            );

            // Show btn to retry
            setShowBtn(true);
            return;
          }
        }else {
          setIsProcessing(false);
          setShowMsg(true);
          setMsg("Liveness check failed...!!!");
          setMsgColor("brown");
          setMsgIcon(<ImCancelCircle />);
          setShowBtn(true);
        }
      } catch (e) {
        console.log("e", e);
        customAlert.showToast("error", "Operation Failed...!!!");
        setIsProcessing(false);
        setShowBtn(true);

        setShowMsg(true);
        setMsg("Operation Failed...!!!");
        setMsgColor("brown");
        throw e;
      }
    } else {
      // Dispatch an error saying "Operation Failed as no data was generated for the user"
      customAlert.showToast(
        "error",
        "Operation Failed as no liveness data was generated for the user"
      );
      setShowBtn(true);
      setIsProcessing(false);

      setShowMsg(true);
      setMsg("Operation Failed as no liveness data was generated for the user");
      setMsgColor("brown");
    }
  };

  // To verify liveness check
  const handleVerifyCheck = async () => {
    showLoader(true);

    // hit api to verify now
    const res = await userLivenessCheckVerify(
      storePrecustomer.precustomer?.precustomerId
    );

    if (res?.status === true) {
      // Trigger alert
      customAlert.showToast("success", res?.message);

      // Make api call to update the onboarding status
      const res4 = await updateCustomerOnboardingStat(
        storePrecustomer.precustomer?.msisdn,
        "LIVENESS_CHECK"
      );

      if (res4?.status === true) {
        // Trigger alert
        customAlert.showToast(
          "success",
          "Verification passed, customer can now proceed...!!!"
        );

        setShowVerifyBtn(false);
        showLoader(false);
        setIsProcessing(false);
        setShowProceedBtn(true);
        setShowMsg(true);
        setMsg("Verified sucessfully, customer can now proceed...!!!");
        setMsgColor("forestgreen");
        setMsgIcon(<AiOutlineCheckCircle />);
        return;
      } else {
        // Make api call to update the onboarding status 
        await updateCustomerOnboardingStat(
          storePrecustomer?.precustomer?.msisdn,
          "BUNDLE_SELECTED"
        );
        
        setIsProcessing(false);
        setShowMsg(true);
        setMsg(
          "Liveness check passed but failed to update onboarding status..!"
        );
        setMsgColor("brown");

        // Trigger alert
        customAlert.showToast(
          "error",
          "Liveness check passed but failed to update onboarding status..!"
        );
        
        // Show btn to retry
        setShowBtn(true);
        return;
      }

    } else {
      // Make api call to update the onboarding status 
      await updateCustomerOnboardingStat(
        storePrecustomer?.precustomer?.msisdn,
        "BUNDLE_SELECTED"
      );

      // Trigger alert
      customAlert.showToast(
        "error",
        res?.message || "No liiveness check status found for this user."
      );
      setShowMsg(true);
      setMsg("Liveness check passed But failed to Verify Liveness check/Image Matching...!!!");
      showLoader(false);
    }
  };

  useEffect(() => {
    const smartCameraElement = smartCameraRef.current;

    if (smartCameraElement) {
      smartCameraElement.addEventListener("imagesComputed", async (e) => {
        try {
          const response = await postContent(e.detail);
          console.log("response", response);
          
        } catch (e) {
          console.error(e);
        }
      });
    }
  }, []);

  return (
    <PageWrapper>
      <PageTitle title="Liveness Check" />

      {showMsg && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "30px 0 0",
            paddingTop: "15px",
            backgroundColor: "white",
            borderRadius: "8px",
          }}
        >
          <h3 style={{ color: msgColor || "black", fontWeight: 600 }}>
            <span style={{ margin: "0 5px 5px 0" }}>{msgIcon}</span>
            {msg}
          </h3>
        </div>
      )}

      {/* Smart identity camera  */}
      <div className="row justify-content-xl-center">
        <smart-camera-web ref={smartCameraRef}></smart-camera-web>
      </div>

      {/* Show button when the liveness check failes  */}
      {showBtn && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className="btn btn-primary btn-lg mr-2"
            onClick={() => handleAction("goBack")}
          >
            Back To Prequalification
          </button>
          <button
            className="btn btn-secondary btn-lg"
            onClick={() => handleAction("refresh")}
          >
            Try Again!
          </button>
        </div>
      )}
      {isProcessing && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader2 />
            </div>
            <h4 style={{ margin: "10px 0 20px" }}>Processing...</h4>
          </div>
        </div>
      )}
      {showVerifyBtn && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className="btn btn-primary btn-lg mr-2"
            onClick={handleVerifyCheck}
          >
            Verify Liveness Check {loader}
          </button>
        </div>
      )}
      {showProceedBtn && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className="btn btn-primary btn-lg mr-2"
            onClick={goToNextPage}
          >
            Proceed
          </button>
        </div>
      )}
    </PageWrapper>
  );
}

export default LivenessCheck;
